import { useQuery } from '@tanstack/react-query';
import { ServiceRegistry } from '@/services/ServiceRegistry';

export const cardsQueryKey = (companyId: string | undefined) => ['cards', companyId] as const;

/** A company's card register with its employees (card-api list). Refused unless the caller may manage cards. */
export function useCards(companyId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: cardsQueryKey(companyId),
    queryFn: () => ServiceRegistry.getCardService().listCards(companyId as string),
    enabled: enabled && !!companyId,
  });
}
